export default "__VITE_ASSET__BE08dXE1__"